import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import StoryFirstYear from './pages/StoryFirstYear';
import StorySecondYear from './pages/StorySecondYear';
import About from './pages/About';
import Help from './pages/Help';
import usePageTracking from './usePageTracking';
import useScrollTracking from './useScrollTracking';
import useReadingTime from './useReadingTime';

function App() {
  usePageTracking();
  useScrollTracking();
  useReadingTime();

  return (
    <div>
      <Navbar />
      <div className="h-24"></div>
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/story/first-year" element={<StoryFirstYear />} />
        <Route path="/story/second-year" element={<StorySecondYear />} />
        <Route path="/story" element={<Navigate to="/story/first-year" replace />} />
        <Route path="/about" element={<About />} />
        <Route path="/help" element={<Help />} />
      </Routes>
    </div>
  );
}

export default App;